import { useState } from 'react';
import { toast } from 'sonner';
import { faComment, faKey, faPaperPlane, faPhone, faWrench, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useSendMessage } from '../../queries/messages';
import { formatPhone } from '../../utils/callLog';
import { Btn, I, cx } from '../Todos/ui';

const MAIN = {
  prospect: ['Schedule showing', faKey, 'tour'],
  applicant: ['Schedule showing', faKey, 'tour'],
  tenant: ['Schedule maintenance', faWrench, 'maint'],
  vendor: ['Schedule maintenance', faWrench, 'maint']
};

const call = (c) => (e) => {
  e?.stopPropagation();
  window.location.href = `tel:${c.phone}`;
};

export default function Quick({ contact: c, icons, primaryCall, onText, onAction }) {
  const main = MAIN[c.type];
  const stop = (fn) => (e) => {
    e?.stopPropagation();
    fn();
  };
  if (icons)
    return (
      <div className="qa7 icons" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="cl3-ib" title="Call" aria-label={`Call ${c.name}`} disabled={!c.phone} onClick={call(c)}>
          <I icon={faPhone} />
        </button>
        <button type="button" className="cl3-ib" title="Text" aria-label={`Text ${c.name}`} disabled={!c.phone} onClick={stop(onText)}>
          <I icon={faComment} />
        </button>
        {main && (
          <button type="button" className="cl3-ib" title={main[0]} aria-label={`${main[0]} for ${c.name}`} onClick={stop(() => onAction(main[2]))}>
            <I icon={main[1]} />
          </button>
        )}
      </div>
    );
  return (
    <div className="qa7" role="group" aria-label={`Quick actions for ${c.name}`}>
      <Btn sm icon={faPhone} kind={primaryCall ? 'primary' : null} disabled={!c.phone} onClick={call(c)}>
        Call
      </Btn>
      <Btn sm icon={faComment} disabled={!c.phone} onClick={onText}>
        Text
      </Btn>
      {main && (
        <Btn sm icon={main[1]} kind={primaryCall ? null : 'primary'} onClick={() => onAction(main[2])}>
          {main[0]}
        </Btn>
      )}
    </div>
  );
}

const first = (name) => String(name || '').split(' ')[0];

function suggestions(c) {
  if (c.type === 'tenant') return [`Hi ${first(c.name)}, following up on your call. Our team will text you a time window today.`];
  if (c.type === 'prospect' || c.type === 'applicant')
    return [`Hi ${first(c.name)}, thanks for calling. Want to set up a tour this week?`];
  return ['Thanks for calling. We will follow up today.'];
}

export function QuickText({ contact: c, onClose, className }) {
  const [t, setT] = useState('');
  const send = useSendMessage();
  const submit = () =>
    send.mutate(
      { contactNumber: c.phone, body: t.trim() },
      {
        onSuccess: () => {
          toast.success(`Text sent to ${c.name}`);
          onClose();
        }
      }
    );
  return (
    <div
      className={cx('ib3-qt', className)}
      role="dialog"
      aria-label={`Quick text to ${c.name}`}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.stopPropagation();
          onClose();
        }
      }}
    >
      <div className="m-row">
        <I icon={faComment} />
        <span className="b sm grow">Quick text to {first(c.name)}</span>
        <span className="m-sub">{formatPhone(c.phone)}</span>
        <button type="button" className="m-x" onClick={onClose} aria-label="Close">
          <I icon={faXmark} />
        </button>
      </div>
      <div className="m-row wrap gap4">
        {suggestions(c).map((x) => (
          <button key={x} type="button" className="m-fchip" onClick={() => setT(x)}>
            {x.length > 46 ? `${x.slice(0, 44)}...` : x}
          </button>
        ))}
      </div>
      <textarea
        className="m-inp"
        rows={3}
        value={t}
        maxLength={320}
        autoFocus
        placeholder="Type a quick text"
        onChange={(e) => setT(e.target.value)}
        aria-label="Quick text"
      />
      <div className="m-row">
        <span className="m-sub num grow">{t.length} / 320</span>
        <Btn sm onClick={onClose}>
          Cancel
        </Btn>
        <Btn sm kind="primary" icon={faPaperPlane} disabled={!t.trim() || send.isPending} onClick={submit}>
          Send text
        </Btn>
      </div>
    </div>
  );
}
